import {ChevronDownIcon, HStack, Pressable} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";
import {Link} from "react-router-dom";

import Text from "@/client/components/Text";

type Props = {
    to: string | (() => void);
    children: string;
    isActive?: boolean;
    icon?: "chevron-down";
    testID?: string;
};

const TopNavMenuItem: React.FC<Props> = ({to, children, isActive, icon, testID}) => {
    const textNode = (
        <Text color={isActive ? "blue.600" : undefined} variant="sm">
            {children}
        </Text>
    );

    return (
        <Pressable
            className="h-full justify-center"
            role="button"
            testID={testID}
            onPress={typeof to === "function" ? to : undefined}
        >
            <HStack className="px-2 py-2 rounded-md items-center" space="sm">
                {typeof to === "string" ? (
                    <Link className="text-sm leading-sm" to={to}>
                        {textNode}
                    </Link>
                ) : (
                    textNode
                )}
                {icon === "chevron-down" && <ChevronDownIcon color="blueGray.400" size="sm" />}
            </HStack>
        </Pressable>
    );
};

export default memo(TopNavMenuItem);
